import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components/index';
import fetch from 'features/common/fetch';

import CampaignsTableBody from './CampaignsTableBody';

export const CampaignsTable = () => (
	<ComponentLoader fetchStorePath={fetch.constants.urls.campaignManagementSummary} forceInlineError>
		<Paper sx={{ py: 2, px: 3, backgroundColor: (theme) => theme.palette.background[100], borderRadius: 1 }}>
			<TableContainer sx={{ height: '315px', border: 'none !important' }}>
				<Table
					size="small"
					sx={{
						border: 'none !important',
						'& .MuiTableCell-root': {
							px: 0,
							borderBottom: 'unset',
							borderTop: (theme) => `1px solid ${theme.palette.divider}`,
						},
					}}
				>
					<TableHead>
						<TableRow
							sx={{
								'& .MuiTableCell-root': {
									backgroundColor: 'unset',
									fontSize: 14,
									color: 'grey.500',
									fontWeight: 400,
									borderTop: 'unset',
								},
							}}
						>
							<TableCell>{getMessage('dashboard:campaigns.campaignName')}</TableCell>
							<TableCell sx={{ pr: '4px !important' }} align="right">
								{getMessage('dashboard:campaigns.daysLeft')}
							</TableCell>
						</TableRow>
					</TableHead>
					<CampaignsTableBody />
				</Table>
			</TableContainer>
		</Paper>
	</ComponentLoader>
);

export default CampaignsTable;
